export default {
    goodsPage: {
        dPs1: 'Reminder',
        dPs2: 'To ensure a smooth inbound process,please:',
        dPs3: '1 Pack the goods according to the quantities listed on the PO page;',
        dPs4: '2 Print out the PO page and place it inside the pallet wrapping for easy verification.',
        dPs5: 'Thank you for your cooperation.',
        dPs6: 'Confirm & Download PO Page',
        review: 'Batch Review',
        ERROR: 'ERROR',
        SUCCESS: 'IMPORT SUCCESS',
        FAILED: 'IMPORT FAILED',
        rejection: 'Batch Rejection',
        skuName: 'Product Name',
        skuCode: 'SKU Code',
        num: 'Number',
        spuName: 'Product Name',
        spuCode: 'Product Code',
        itemType: 'Product Type',
        uomGroup: 'UOM Group',
        asignBarcode: 'Use system barcode',
        barCode: 'Barcode',
        skuDesc: 'Description',
        qty: 'Item Per Carton',
        fragile: 'Is It Wine',
        needExpired: 'Batch and Expiration',
        Serial: 'Serial Number',
        vendorName: 'Supplier',
        buyingDepName: 'Purchasing Department',
        buyerName: 'Purchasing agent',
        cartonBoxBarcode: 'Outer packaging barcode',
        seasonable: 'Seasonal products',
        merchandiser: 'Ebay Merchandiser',
        merchandiser2: 'Amz Merchandiser',
        discontinued: 'Continue to sell',
        rmb: 'RMB',
        inventoryItem: 'Inventory Products',
        purchaseItem: 'Purchased Item',
        salesItem: 'Sale item',
        dangerousGoods: 'Dangerous Goods',
        flammable: 'Flammable',
        imageUrl: 'Picture',
        Dimensional: 'Dimension Verification',
        auditIdea: 'Audit Idea',
        need: 'Batch and Expiration',
        packingM: 'Packing Method',
        packingT: 'Package Type',

        categoryName: 'Product Category',
        brandName: 'Product Brand',
        material: 'Material',
        productTypes: 'Product Type',
        packageProduct: 'Add package product',
        generalMerchandise: 'Add General Product',
        brandNameTable: 'Brand name',
        // materialNameText: 'Material name',
        confirm1: 'You are submitting data for review. Are you sure you want to continue?',
        msgWarning: 'TODO:Incomplete product information for SP001. Please complete the product information.',

        // materialName: 'Material Name',
        MainImage: 'Main picture',
        DetailMap: 'Detail picture',
        description: 'Product Description',
        itemPerCarton: 'Item Per Carton',
        costPrice: 'Cost Price',
        salesPrice: 'Selling price',
        Predicted: 'Predicted or not',
        prediction: 'Predicted',
        Not: 'Unpredicted',
        Actual: 'Actual profit margin',
        Standard: 'Standard profit margin',
        rate: 'Resend/Refund rate',

        weight: 'Unit/WT',
        length: 'Unit/L',
        width: 'Unit/W',
        height: 'Unit/H',
        volume: 'Unit/CBM',
        rule: 'rule',
        ps1: 'Missing required field.',
        ps4: '【Cost price】 format error.',
        ps5: '【Unit per carton】 format error',
        ps6_1: '【Unit length】 format error',
        ps6_2: '【Unit width】 format error',
        ps6_3: '【Unit height】 format error',
        ps6_4: '【Unit weight】 format error',
        ps7_1: '【Carton length】 format error',
        ps7_2: '【Carton width】 format error',
        ps7_3: '【Carton height】 format error',
        ps7_4: '【Carton weight】 format error',
        ps8: 'Unit length should ≤ carton length',
        ps9: 'Unit width should ≤ carton width',
        ps10: 'Unit height should ≤ carton height.',
        ps11: 'Unit weight * unit per carton should ≤ carton weight.',
        ps12: 'Spaces are not allowed in sku',
        ps121: 'Spaces are not allowed in sales kit sku',
        ps13: 'Invalid format: formulas detected. Please enter manually.',
        rule1: '1.Required fields: Products Name, SKU, Product Type, Unit Length, Unit Width, Unit Height, Unit Weight.',
        rule2: '2.The SKU code allows hyphens and underscores, but spaces and other special characters are not allowed.',
        rule3: '3.Batch and expiration must be yes or no.',
        rule13: '13.Serial Number must be yes or no.',
        rule4: '4.Cost price can be left blank; if blank, the default is 0. If not blank, it must be a non-negative number with up to 2 decimal places.',
        rule5: '5.Unit per carton can be left blank; if blank, the default is 1. If not blank, it must be a positive integer.',
        rule6: '6.Unit length, width, height, weight, must be positive numbers with up to 2 decimal places.',
        rule7: '7.If unit per carton is blank or 1, carton length, carton width, carton height, carton weight can be left blank. If unit per carton > 1, these fields are required and must be positive numbers with up to 2 decimal places.',
        rule8: '8.Unit length ≤ carton length.',
        rule9: '9.Unit width ≤ carton width.',
        rule10: '10.Unit height ≤ carton height.',
        // rule11: '11.Unit volume * unit per carton ≤ carton volume.',
        rule11: '11.Unit weight * unit per carton ≤ carton weight.',
        rule12: '12.The barcode must be up to 14 characters, with no spaces or special characters.',
        barcodeRule: 'barcode cannot start or end with a space.',
        package:{
            Name: 'Package Name',
            SKU:'Package SKU',
            Barcode: 'Package Barcode',
            Method: 'Packing Method',
            Type: 'Package Type',
            Supplier: 'Supplier',
            Cost: 'Package Cost',
            Price: 'Package Price',
            fee: 'Packing fee',
            Length: 'Length(CM)',
            Width: 'Width(CM)',
            Height: 'Height(CM)',
            Weight: 'Weight(KG)',
            order: 'Order Packaging Materials',
            product: 'Product Packaging Materials',
            csg: 'CSG Packaging Materials',
            cus: 'Customer Packaging Materials',
            Info:'Package Information',
            edit:'Package Edit',
            Selectpackagingmaterials: 'Select packaging materials',
            num: 'Qty',
            money1: 'Material Fee(AUD)',
            money2: 'Labour Fee(AUD)',
            bindSKU: 'Bind SKU',
            bindInfo: 'Binding Information',
        },
    }
};
